import { createTypes, createAction } from "lib/action";

const LOAD_DISTANCE = createTypes("distance", "load");
const SHOW_DISTANCE = createTypes("distance", "show");
const CREATE_DISTANCE = createTypes("distance", "create");
const UPDATE_DISTANCE = createTypes("distance", "update");
const DELETE_DISTANCE = createTypes("distance", "delete");
const IMPORT_DISTANCE = createTypes("distance", "import");
const EXPORT_DISTANCE = createTypes("distance", "export");

const loadDistances = {
  request: (params, token) =>
    createAction(LOAD_DISTANCE.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_DISTANCE.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_DISTANCE.FAILURE, { err }),
};

const showDistance = {
  request: (id, token) => createAction(SHOW_DISTANCE.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_DISTANCE.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_DISTANCE.FAILURE, { err }),
};

const createDistance = {
  request: (params, token) =>
    createAction(CREATE_DISTANCE.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_DISTANCE.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_DISTANCE.FAILURE, { err }),
};

const updateDistance = {
  request: (params, id, token) =>
    createAction(UPDATE_DISTANCE.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_DISTANCE.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_DISTANCE.FAILURE, { err }),
};

const deleteDistance = {
  request: (id, token) => createAction(DELETE_DISTANCE.REQUEST, { id, token }),
  success: (id) => createAction(DELETE_DISTANCE.SUCCESS, { id }),
  failure: (err) => createAction(DELETE_DISTANCE.FAILURE, { err }),
};

const importDistance = {
  request: (file, company_id, token) =>
    createAction(IMPORT_DISTANCE.REQUEST, { file, company_id, token }),
  success: (data) => createAction(IMPORT_DISTANCE.SUCCESS, { data }),
  failure: (err) => createAction(IMPORT_DISTANCE.FAILURE, { err }),
};

const exportDistance = {
  request: (token) => createAction(EXPORT_DISTANCE.REQUEST, { token }),
  success: (data) => createAction(EXPORT_DISTANCE.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_DISTANCE.FAILURE, { err }),
};

export {
  loadDistances,
  showDistance,
  createDistance,
  updateDistance,
  deleteDistance,
  importDistance,
  exportDistance,
  LOAD_DISTANCE,
  SHOW_DISTANCE,
  CREATE_DISTANCE,
  UPDATE_DISTANCE,
  DELETE_DISTANCE,
  IMPORT_DISTANCE,
  EXPORT_DISTANCE,
};
